import React from 'react'
import TextBox from './TextBox'
import {mergeAttrs} from '../helpers/react-helpers'
import css from './NumberBox.less'
import Icon from './Icon'
import cn from 'classnames'
import {parseInt} from '../util/math'
import {ActionButtonIcon} from './SaveSubmitButton'
import icons from '../../markons/markons'

type Props = OverrideProps<typeof TextBox, {
    step?: number;
    width?: string;
    icon?: string;
    value: number
}>

export default class NumberBox extends React.Component<Props> {

    static defaultProps = {
        step: 1,
    }

    increment = (dir: any) => (ev: any) => {
        if(!this.props.onChange) return
        let value = parseInt(this.props.value, 0) + dir * this.props.step!
        if(this.props.min != null && value < this.props.min) {
            value = this.props.min
        }
        if(this.props.max != null && value > this.props.max) {
            value = this.props.max
        }
        this.props.onChange({
            target: {value}
        })
    }

    blur = (ev: any) => {
        if(!this.props.onChange) return
        let value = parseInt(this.props.value, 0)
        if(this.props.min != null && value < this.props.min) {
            value = this.props.min
        }
        if(this.props.max != null && value > this.props.max) {
            value = this.props.max
        }
        if(value != this.props.value) {
            this.props.onChange({
                target: {value}
            })
        }
    }

    render() {
        const {width, icon, onBlur, ...props} = this.props
        const step = this.props.step!


        return (
            <span className={css.wrap} style={{width}}>
                {icon ? <span className={css.passengerIcon}><Icon name={icon} /></span> : null}
                <ActionButtonIcon className={cn(css.button, css.left, icon ? css.hasIcon : false)}
                    onClick={this.increment(-step)}
                    icon={icons.faMinus}
                    disabled={this.props.min != null && (this.props.value - step) < this.props.min} />
                <TextBox {...mergeAttrs({className: css.input, type: 'number', onBlur: this.blur}, props)} />
                <ActionButtonIcon className={`${css.button} ${css.right}`}
                    onClick={this.increment(step)}
                    disabled={this.props.max != null && (this.props.value + this.props.step) > this.props.max}
                    icon={icons.miscPlus} />
            </span>
        )
    }
}
